module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/logs/logs.component.css
// module id = ./src/app/logs/logs.component.css
// module chunks = main